import { doLogin } from '../../../credentialsManager';
import { getStartedWithStart } from '../../../cliAgentMode';
import { getPackageVersion } from '../../../testimNpmDriver';
import type { Express } from 'express';


export function orchestrateGeneralRoutes(app: Express) {
    app.get<never, { success: true; isTestimAgent: true; startMode: boolean }>('/', (req, res) => {
        const isStartMode = getStartedWithStart();

        return res.status(200).json({ success: true, isTestimAgent: true, startMode: isStartMode });
    });

    app.get<never, { node: string; app: string }>('/version', (req, res) => {
        res.status(200).json({
            node: process.version,
            app: getPackageVersion(),
        });
    });

    app.get<never, never, never, { info: string }>('/loginInfo', (req, res) => {
        try {
            const projects = JSON.parse(Buffer.from(req.query.info, 'base64').toString());
            doLogin({ overwriteExisting: false, projects });
            res.status(200).end();
        } catch (err) {
            res.status(400).end();
        }
    });
}
